import angular from 'angular';

import JSONValidatorModule from './json.validator';

const ValidatorsModule = angular.module('control-room.commons.form.validators', [JSONValidatorModule.name]);

export default ValidatorsModule;
